import ListCreateButton from 'components/buttons/ListCreateButton';
import PageHeader from 'components/PageHeader';
import PaddedLayout from 'layout/MainLayout/PaddedLayout';
import { useNavigateWithReturnState } from 'utils/useNavigateWithReturnState';
import PracticeAreasTableWithFilters from './PracticeAreasTable';

const PracticeAreasListPage = (): JSX.Element => {
    const navigateWithReturn = useNavigateWithReturnState();

    return (
        <PaddedLayout className="overflow-hidden">
            <div className="flex h-full flex-col gap-4">
                <PageHeader
                    hostsList
                    titleId={'practice-areas.practice-areas'}
                    showBreadcrumb
                    buttons={
                        <div>
                            <ListCreateButton
                                permissions={['CREATE.PRACTICE_AREAS']}
                                variant="contained"
                                color="secondary"
                                size="small"
                                onClick={() => navigateWithReturn(`/practice-area/new`)}
                                labelId="practice-areas.add-new-practice-area"
                                newLabelId="new-entity.practice-area"
                            />
                        </div>
                    }
                />
                <PracticeAreasTableWithFilters />
            </div>
        </PaddedLayout>
    );
};

export default PracticeAreasListPage;
